import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BadgePercent } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const INPUT = "w-full bg-[#121212] border border-white/[0.06] rounded-md px-3 py-2 text-white text-sm focus:outline-none focus:border-white/20";

export default function FlexfuelOfferSettings() {
  const [cfg, setCfg] = useState(null);
  const [state, setState] = useState(null);
  const [saving, setSaving] = useState(false);

  const loadState = () => axios.get(`${API}/api/flexfuel-offer`).then((r) => setState(r.data)).catch(() => {});
  useEffect(() => {
    axios.get(`${API}/api/content/flexfuel_offer?raw=1`).then((r) => setCfg(r.data)).catch(() => {});
    loadState();
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/api/admin/content/flexfuel_offer`, {
        ...cfg, offer_price: Number(cfg.offer_price), regular_price: Number(cfg.regular_price),
      });
      toast.success("Offre Flexfuel enregistrée");
      loadState();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur à l'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  if (!cfg) return null;
  return (
    <div data-testid="flexfuel-offer-settings" className="bg-[#1C1C1E] border border-[#FF3B30]/25 rounded-md p-3 space-y-3">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <p className="text-white text-sm font-semibold flex items-center gap-2">
          <BadgePercent size={15} className="text-[#FF3B30]" /> Offre Flexfuel (prix affiché sur tout le site)
        </p>
        <label className="flex items-center gap-2 text-white/70 text-xs cursor-pointer">
          <input type="checkbox" checked={cfg.enabled !== false} onChange={(e) => setCfg({ ...cfg, enabled: e.target.checked })}
            data-testid="flexfuel-offer-enabled" className="accent-[#FF3B30]" />
          Offre active
        </label>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <label className="text-white/50 text-xs uppercase tracking-wider">Prix promo (€ TTC)
          <input type="number" value={cfg.offer_price} onChange={(e) => setCfg({ ...cfg, offer_price: e.target.value })} data-testid="flexfuel-offer-price" className={`${INPUT} mt-1.5`} />
        </label>
        <label className="text-white/50 text-xs uppercase tracking-wider">Prix normal (€ TTC)
          <input type="number" value={cfg.regular_price} onChange={(e) => setCfg({ ...cfg, regular_price: e.target.value })} data-testid="flexfuel-offer-regular-price" className={`${INPUT} mt-1.5`} />
        </label>
        <label className="text-white/50 text-xs uppercase tracking-wider">Fin de l&apos;offre (incluse)
          <input type="date" value={cfg.end_date || ""} onChange={(e) => setCfg({ ...cfg, end_date: e.target.value })} data-testid="flexfuel-offer-end-date" className={`${INPUT} mt-1.5`} />
        </label>
      </div>
      <p className="text-white/40 text-[11px]">
        Après la date de fin, le site repasse automatiquement au prix normal. Dans les textes, utilise{" "}
        <code className="text-white/80">{"{prix_flexfuel}"}</code> (prix complet) ou <code className="text-white/80">{"{prix_flexfuel_court}"}</code> (ex : 306€).
      </p>
      {state && (
        <p data-testid="flexfuel-offer-preview" className="text-xs">
          <span className={state.active ? "text-emerald-400 font-semibold" : "text-white/50 font-semibold"}>
            {state.active ? "Offre en cours" : "Prix normal"}
          </span>
          <span className="text-white/70"> — affiché : « {state.label} »</span>
        </p>
      )}
      <button type="button" onClick={save} disabled={saving} data-testid="flexfuel-offer-save"
        className="bg-[#FF3B30] hover:bg-[#D63025] disabled:opacity-50 text-white text-xs font-semibold px-3 py-2 rounded transition-colors">
        {saving ? "Enregistrement…" : "Enregistrer l'offre"}
      </button>
    </div>
  );
}
